
import Vue from "vue";
import { Mixins } from "vue-property-decorator";
import CartMixin from "@/mixins/CartMixin.vue";
import SalesRepFeedbackMixin from "@/mixins/SalesRepFeedbackMixin.vue";
import CommentMixin from "@/mixins/CommentMixin.vue";
export default class SalesRepCartAndFeedbackAndCommentMixin extends Mixins<
  CartMixin,
  SalesRepFeedbackMixin,
  CommentMixin
>(CartMixin, SalesRepFeedbackMixin, CommentMixin) {}
